<template>
  <div>
    <div class="container-fluid full-height">
      <div class="row row-height">
        <hello />
        <!-- /content-left -->

        <div id="start" class="col-lg-6">
          <div id="wizard_container">
            <div class="mb-2">
              <LanguageSelect />
            </div>

            <!-- /top-wizard -->
            <form id="wrapped" method="POST" @submit.prevent="login">
              <input id="website" name="website" type="text" value />
              <!-- Leave for security protection, read docs for details -->
              <div id="middle-wizard">
                <div class="submit step">
                  <h3 class="main_question">{{ $t('Hoşgeldin') }}!</h3>
                  <InputField
                    v-model.trim="email"
                    name="email"
                    :placeholder="$t('E-posta')"
                    v-validate="'required|email'"
                    :error="errors.first('email')"
                    :validateFields="fields['email']"
                  />
                  <InputField
                    v-model="password"
                    name="password"
                    :placeholder="$t('Şifre')"
                    v-validate="'required'"
                    :error="errors.first('password')"
                    type="password"
                    :validateFields="fields['password']"
                  />
                </div>

                <button :disabled="isWaiting" class="submit" name="process" type="submit">
                  {{ $i18n.locale === 'tr' ? $t('Giriş Yap').toLocaleUpperCase() : $t('Giriş Yap').toUpperCase() }}
                </button>
              </div>
              <!-- /middle-wizard -->
              <div id="bottom-wizard"></div>
              <!-- /bottom-wizard -->
              <div class="form-group">
                <div class="row">
                  <div class="col-12">
                    <strong>
                      <router-link :to="pathFindWithLanguage('/forgot-password')"
                        >{{ $t('Şifremi Unuttum') }}?</router-link
                      >
                    </strong>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-12">
                    <strong>
                      {{ $t('Hesabınız yok mu?') }}
                      <router-link :to="pathFindWithLanguage('/')">{{ $t('Kayıt olmak için tıklayın') }}</router-link>
                    </strong>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <!-- /Wizard container -->
        </div>
        <!-- /content-right-->
      </div>
      <!-- /row-->
    </div>
    <!-- /container-fluid -->
  </div>
</template>
<script>
import CompanyStore from '../stores/company';
import LanguageSelect from './../components/LanguageSelect.vue';
import InputField from './../components/InputField.vue';

export default {
  components: {
    LanguageSelect,
    InputField,
  },
  data() {
    return {
      email: null,
      password: null,
      showReCaptcha: this.$store.getters.getAttemptCount >= this.$store.getters.getMaxAttempts,
    };
  },
  created() {
    if (parseInt(this.$route.query.logout) === 1) {
      this.logout(false);
    }
  },
  methods: {
    login() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const form = $('form#wrapped');

          form.validate();

          if (form.valid()) {
            this.startWaiting();

            $axios
              .post('oauth/token', {
                username: this.email,
                password: this.password,
                grant_type: 'password',
                client_id: process.env.VUE_APP_API_CLIENT_ID,
                client_secret: process.env.VUE_APP_API_CLIENT_SECRET,
                scope: '*',
                app_id: this.$route.query.appid ? this.$route.query.appid : undefined,
              })
              .then(
                (s) => {
                  this.$store.commit('clearLoginAttempts');
                  const responseData = s.data;
                  if (this.$route.query.appid && responseData.redirect_url) {
                    window.location = `${responseData.redirect_url}/?company_id=${responseData.company_id}&encrypted_token=${responseData.access_token}`;
                  } else {
                    this.setAccessToken(responseData);
                    this.$toasted.show(this.$t('AlertMessages.Giriş yapılıyor'));
                    // Get user info
                    this.$store.dispatch('getSelfWithCompanies').then(() => {
                      const user = this.getSelf();
                      // Hubspot Update
                      CompanyStore.dispatch('informHubspot', {
                        name: user.name,
                        surname: user.surname,
                        email: user.email,
                      });
                      window.location = this.getLoginUrl();
                    });
                  }
                },
                (e) => {
                  this.$toasted.error(this.$t('AlertMessages.Yanlış e-posta adresi veya şifre'));
                  this.endWaiting();
                }
              );
          }
        }
      });
    },
  },
};
</script>
